import React from 'react';
import { Grid } from '@mui/material';
import { dropBoolean, dropTipoEndereco } from 'utils/drops';
import Input from 'components/Input';
import Dropdown from 'components/Dropdown';

const Filter = ({ grid, control, drops }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('celocal_id') && (
        <Grid item xs={12}>
          <Dropdown
            name="celocal_id"
            control={control}
            label="Local de Estoque"
            options={drops?.LocalEstoque}
            multiple
            disabled
          />
        </Grid>
      )}
      {checkDisplay('endereco') && (
        <Grid item xs={12}>
          <Input
            name="endereco"
            control={control}
            label="Endereço de Estoque"
          />
        </Grid>
      )}
      {checkDisplay('tipo') && (
        <Grid item xs={12}>
          <Dropdown
            name="tipo"
            control={control}
            label="Tipo"
            options={dropTipoEndereco}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('posicao') && (
        <Grid item xs={12}>
          <Input name="posicao" control={control} label="Posição" />
        </Grid>
      )}
      {checkDisplay('x') && (
        <Grid item xs={12}>
          <Input name="x" control={control} label="X" type="number" />
        </Grid>
      )}
      {checkDisplay('y') && (
        <Grid item xs={12}>
          <Input name="y" control={control} label="Y" type="number" />
        </Grid>
      )}
      {checkDisplay('picking') && (
        <Grid item xs={12}>
          <Dropdown
            name="picking"
            control={control}
            label="Picking"
            options={dropBoolean}
          />
        </Grid>
      )}
      {checkDisplay('ativo') && (
        <Grid item xs={12}>
          <Dropdown
            name="ativo"
            control={control}
            label="Ativo"
            options={dropBoolean}
          />
        </Grid>
      )}
      {checkDisplay('disponivel') && (
        <Grid item xs={12}>
          <Dropdown
            name="disponivel"
            control={control}
            label="Disponível"
            options={dropBoolean}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
